// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveTransferMajorDisciplineFrameworkElementDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import TransferMajorDisciplineFrameworkElementDTO from '../models/TransferMajorDisciplineFrameworkElementDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    transferMajorDisciplineFrameworkElementId: number;
    transferMajorDisciplineFrameworkElement: TransferMajorDisciplineFrameworkElementDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            transferMajorDisciplineFrameworkElementId: 0,
            transferMajorDisciplineFrameworkElement: null,
        },
        initValues);
    },
    transferMajorDisciplineFrameworkElementId: 'transferMajorDisciplineFrameworkElementId',
    transferMajorDisciplineFrameworkElement: 'transferMajorDisciplineFrameworkElement',
}

interface Result extends ResultDTO {
    transferMajorDisciplineFrameworkElement: TransferMajorDisciplineFrameworkElementDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            transferMajorDisciplineFrameworkElement: null,
        },
        initValues);
    },
    transferMajorDisciplineFrameworkElement: 'transferMajorDisciplineFrameworkElement',
}

export { Request, Result };